import React, { useContext } from "react";
import GlobalContext from "../../context/global";

const Intro = () => {
  const appData = useContext(GlobalContext);
  const {
    dealerProfile: { whiteLabel },
  } = appData;
  const determiner = whiteLabel ? "These" : <i>Car and Driver</i>;
  return (
    <>
      {determiner} values are calculated using the same Black Book
      <sup>&reg;</sup> data used by dealers across the country to appraise
      vehicles.
    </>
  );
};

export default Intro;
